export const LILY_FAMILY_OPT_OUT = 'lily_family_opt_out';
